import { render, staticRenderFns } from "./CSPModal.vue?vue&type=template&id=4152b6bd&scoped=true"
import script from "./CSPModal.vue?vue&type=script&lang=js"
export * from "./CSPModal.vue?vue&type=script&lang=js"
import style0 from "./CSPModal.vue?vue&type=style&index=0&id=4152b6bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4152b6bd",
  null
  
)

export default component.exports